import { getAxiosClient } from "../axios";

export const getActiveProducts = async (id, params) => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .get(`/organizations/${id}/products`, { params: { ...params, "status": "Actief"}} )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};

export const getProducts = async (id, params) => {
  const axiosClient = await getAxiosClient();

  return await axiosClient
    .get(`/organizations/${id}/products`, { params: {...params}} )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("error", error);
      return Promise.reject(error);
    });
};

export const addProduct = async (organizationId, product) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .post(`/organizations/${organizationId}/products`, product)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };

  export const getProduct = async (productId) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .get(`/products/${productId}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };
  
  export const updateProduct = async (product) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .put(`/products/${product.id}`, product)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };
  
  export const deleteProduct = async (productID) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .delete(`/products/${productID}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };

  export const deactivateProduct = async (productID) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .put(`/products/${productID}/deactivate`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };

  export const activateProduct = async (productID) => {
    const axiosClient = await getAxiosClient();
  
    return await axiosClient
      .put(`/products/${productID}/activate`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };

  export const uploadCover = async (id, file) => {
    const axiosClient = await getAxiosClient();
  
    const formData = new FormData();
    formData.append("file", file);

    return await axiosClient
      .put(`/products/${id}/cover`, formData, { "content-type": "multipart/form-data" })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log("error", error);
        return Promise.reject(error);
      });
  };
